import { NodeViewWrapper, type ReactNodeViewProps, useEditorState } from "@tiptap/react";
import { getHost } from "../host";

const orNull = (v: string) => (v.trim() === "" ? null : v);

export function ImageView({ node, editor, selected, updateAttributes }: ReactNodeViewProps) {
  const editable = useEditorState({ editor, selector: ({ editor: e }) => e.isEditable });
  const src = String(node.attrs.src ?? "");
  const caption = (node.attrs.caption as string | null) ?? "";
  const alt = (node.attrs.alt as string | null) ?? "";
  const update = (attrs: Record<string, unknown>) => {
    if (editor.isEditable) updateAttributes(attrs);
  };
  return (
    <NodeViewWrapper as="figure" className={selected ? "kd-figure is-selected" : "kd-figure"} data-drag-handle="">
      <img src={getHost(editor).attachmentUrl(src)} alt={alt} draggable={false} />
      {editable ? (
        <div className="kd-figure__fields" contentEditable={false}>
          <input
            aria-label="Caption"
            placeholder="Caption (optional)"
            value={caption}
            onChange={(e) => update({ caption: orNull(e.target.value) })}
          />
          <input
            aria-label="Alt text"
            placeholder="Describe the image for screen readers"
            value={alt}
            onChange={(e) => update({ alt: orNull(e.target.value) })}
          />
        </div>
      ) : caption ? (
        <figcaption>{caption}</figcaption>
      ) : null}
    </NodeViewWrapper>
  );
}
